"use client";

import { Chart, useChart } from "@chakra-ui/charts";
import {
  Line,
  LineChart,
  ResponsiveContainer,
} from "recharts";
import { Box } from "@chakra-ui/react";

import {
  Button,
  Flex,
  IconButton,
  Image,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
// import SvgIcAgreements from "assets/svg/SvgIcAgreements";
import ButtonComp from "./Button";
// import { SlArrowRight } from "react-icons/sl";
import { RiArrowRightSLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import useCheckMobileScreen from "hooks/useCheckMobileScreen";

const Chart2 = (data) => {
  const chart = useChart(data);

  // const datax = {
  //   data: [
  //     { name: "Jan", value: 400 },
  //     { name: "Feb", value: 300 },
  //     { name: "Mar", value: 500 },
  //     { name: "Apr", value: 600 },
  //     { name: "May", value: 700 },
  //     { name: "Jun", value: 800 },
  //     { name: "Jul", value: 900 },
  //   ],
  // };

  return (
    <Box width="100%" height="0.8rem" fontFamily="body">
      <Chart.Root chart={chart} width="100%" height="100%">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chart.data}>
            {/* <CartesianGrid stroke={chart.color("border")} vertical={false} /> */}
            {/* <XAxis
              dataKey={chart.key("month")}
              tickFormatter={(value) => value.slice(0, 3)}
              axisLine={false}
              tickLine={false}
              stroke={chart.color("border")}
            /> */}
            {/* <YAxis
              axisLine={false}
              tickLine={false}
              tickMargin={10}
              stroke={chart.color("border")}
            /> */}
            {/* <Tooltip
              animationDuration={100}
              cursor={false}
              content={<Chart.Tooltip />}
            /> */}
            {chart.series.map((item) => (
              <Line
                key={item.name}
                type="monotone"
                dataKey={chart.key(item.name)}
                stroke={chart.color(item.color)}
                strokeWidth={2}
                dot={{ r: 0 }}
                isAnimationActive={false}
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </Chart.Root>
    </Box>
  );
};

export const CardInfo = ({
  label,
  buttonTRData,
  type,
  selected,
  count,
  countDetail,
  chartData,
  buttonBRData,
  buttonList,
  route,
}) => {
  const ismobile = useCheckMobileScreen();
  const navigate = useNavigate();

  const onNavigate = (v) => {
    if (v) {
      navigate(`/${v}`, {});
    }
  };

  // const w = ismobile ? "15rem" : "30rem";

  return (
    <Flex
      p={"2px"}
      // borderWidth={"6px"}
      // flex={"1 1 200px"}
      // minW={w}
      // maxW={"50rem"}

      alignItems={"center"}
      justifyContent={"center"}
      //  height: 200px;
      display="flex"
      // data-state="open"
      // animationDuration="slow"
      // animationStyle={{ _hover: "slide-fade-in" }}
      //   whileHover={{ scale: 1.1, rotate: "-360deg" }}
      // whileTap={{
      //   scale: 0.95,
      //   borderRadius: "10rem",
      // }}
      // transition="all 0.3s ease-in-out"
      // _hover={{
      // transform: 'translateY(-10px)',
      // animation: `${bounce} 0.6s ease infinite`,
      // }}

      transform="translateY(0)"
      transition="transform 0.3s ease, box-shadow 0.3s ease"
      _hover={{
        transform: "translateY(-5px)",
        // boxShadow: 'lg',
      }}
    >
      <Flex
        color={"white"}
        borderRadius={"0.5rem"}
        // bg={"primary"}
        overflow={"hidden"}
        justify={"space-between"}
        px={"1rem"}
        py={"0.5rem"}
        boxShadow={"sm"}
        borderBottomWidth={"0.5px"}
        borderColor={"shadow"}
        // borderWidth={"4px"}
        // w={w}
        flex={1}
        direction={"column"}
        alignSelf={"start"}
        borderWidth={"1px"}

        // alignItems={'start'}
        // justifyItems={'start'}
        // justifyContent={'start'}
        // maxW={'25rem'}
        // flex={1}
        // w={'100%'}
      >
        {/* <Flex position={"absolute"} right={"1rem"}> */}

        {/* </Flex> */}
        <Flex justify={"space-between"}>
          <Flex direction={"column"}>
            <Text
              color={"text"}
              fontSize={"xl"}
              lineClamp={1}
              // textStyle={"lg"}

              // fontWeight={'bold'}
              // w={w}
              // overflow={"hidden"}
              // lineClamp={1}
              // textAlign={"left"}
              // p={"1rem"}
              // textWrap={"nowrap"}
            >
              {label || " "}
            </Text>
            {buttonList && buttonList[0].key ? null : (
              <>
                <Text
                  color={"textv2"}
                  // fontSize={"1.6rem"}
                  fontSize={"3xl"}
                  fontWeight={"bold"}
                  lineClamp={1}
                >
                  {count || ""}&nbsp;
                </Text>
                {/* <Text
                  color={"textv2.brand"}
                  fontSize={"sm"}
                  // fontWeight={"bold"}
                  lineClamp={1}
                >
                  {countDetail || ""}
                  &nbsp;
                </Text> */}
              </>
            )}
          </Flex>
          <IconButton
            // position={"absolute"}
            // alignSelf={"start"}
            // ml={"22.5rem"}
            // mt={"1rem"}
            p={0}
            m={0}
            mt={"0.3rem"}
            variant={"ghost"}
            h={"100%"}
          >
            {/* <buttonTRData.IcImg fill={"red"} /> */}
            <Image
              src={buttonTRData?.imgIc}
              objectFit={"contain"}
              w={ismobile ? "2rem" : "3.5rem"}
            />
          </IconButton>
        </Flex>

        {buttonList && buttonList[0].key ? (
          <Flex
            direction={"column"}
            alignItems={"start"}
            justify={"space-between"}
            pt={"1rem"}
          >
            <SimpleGrid
              height="5rem"
              columns={3}
              gapX={ismobile ? "0.5rem" : "1rem"}
            >
              {buttonList.map((a) => (
                <ButtonComp
                  keyname={"home-card-br"}
                  {...buttonBRData}
                  key={a.key}
                  label={a.label}
                  bg={a.bgClr}
                  fontSize={ismobile ? "0.5rem" : "0.8rem"}
                  onClick={() => onNavigate(a?.route)}
                />
              ))}
            </SimpleGrid>
            <Button
              // mt={"rem"}
              // variant={"plain"}
              // px={0}
              // gap={0}
              // fontWeight={"normal"}
              onClick={() => onNavigate(route)}
              variant={"plain"}
              px={0}
              gap={0}
              fontWeight={"normal"}
            >
              ViewDetails
              <RiArrowRightSLine />
            </Button>
          </Flex>
        ) : (
          <>
            <Chart2 {...chartData} />

            <Flex justify={"space-between"} alignItems={"center"}>
              <Button
                onClick={() => onNavigate(route)}
                variant={"plain"}
                px={0}
                gap={0}
                fontWeight={"normal"}
              >
                ViewDetails
                <RiArrowRightSLine />
              </Button>
              {buttonBRData ? (
                <ButtonComp
                  keyname={"home-card-br"}
                  {...buttonBRData}
                  onClick={() => onNavigate(buttonBRData.route)}
                />
              ) : null}
            </Flex>
          </>
        )}
      </Flex>
    </Flex>
  );
};
